(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-description-expandable"] && !Shopify.designMode) return;
  try {
    (function () {
    function initExpandableDescription(container) {
      const content = container.querySelector('[data-product-description-expandable] .product-description-expandable__content');
      const toggle = container.querySelector('[data-product-description-toggle]');
      if (!content || !toggle) return;

      // Heading phrases for "What's in the box" across published locales.
      // These come from the actual product-description translations, not theme locales.
      const boxHeadings = [
        "what's in the box",
        "in the box",
        "box contents",
        "package contents",
        "komplekte",
        "lieferumfang",
        "contenu de la boîte",
        "contenido de la caja",
        "contenuto della confezione",
        "in de doos",
        "i lådan",
        "i æsken",
        "obsah balení",
        "obsah balenia",
        "a dobozban",
        "conținutul cutiei",
        "съдържание на комплекта",
        "sadržaj pakiranja",
        "περιεχόμενα συσκευασίας",
        "zawartość opakowania",
        "toimitussisältö",
        "komplektis",
        "komplektācijā",
        "conteúdo da caixa",
        "комплектация",
        "vsebina paketa",
        "i esken",
        "paket içeriği",
        "hộp bao gồm",
        "boxen innehåller",
        " Medfølger",
        "i pakken"
      ];
      const boxPattern = new RegExp(
        '^\\s*(' +
          boxHeadings
            .map(function (h) {
              return h.replace(/[.*+?^${}()|[\\]\\\\]/g, '\\$&');
            })
            .join('|') +
          ')',
        'iu'
      );
      const headingTags = 'h1, h2, h3, h4, h5, h6, strong, b, p';
      const candidates = Array.from(content.querySelectorAll(headingTags));
      const boxHeading = candidates.find(function (el) {
        return boxPattern.test(el.textContent.trim());
      });

      if (!boxHeading) return;

      // The "In the Box" section usually consists of the heading plus the following list.
      // We keep that section visible and collapse everything that comes after it.
      let cutoff = boxHeading;
      let next = boxHeading.nextElementSibling;
      if (next && (next.tagName === 'UL' || next.tagName === 'OL')) {
        cutoff = next;
      }

      const siblingsToWrap = [];
      let sibling = cutoff.nextElementSibling;
      while (sibling) {
        siblingsToWrap.push(sibling);
        sibling = sibling.nextElementSibling;
      }

      if (siblingsToWrap.length === 0) return;

      const wrapper = document.createElement('div');
      wrapper.className = 'product-description-expandable__truncated';
      siblingsToWrap.forEach(function (node) {
        wrapper.appendChild(node);
      });
      cutoff.parentNode.insertBefore(wrapper, cutoff.nextElementSibling);

      toggle.removeAttribute('hidden');

      toggle.addEventListener('click', function () {
        const isExpanded = wrapper.classList.contains('is-expanded');
        if (isExpanded) {
          wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
          wrapper.offsetHeight; // force reflow
          wrapper.style.maxHeight = '';
          wrapper.classList.remove('is-expanded');
          toggle.classList.remove('is-expanded');
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          wrapper.classList.add('is-expanded');
          wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
          toggle.classList.add('is-expanded');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });

      wrapper.addEventListener('transitionend', function (event) {
        if (event.propertyName === 'max-height' && wrapper.classList.contains('is-expanded')) {
          wrapper.style.maxHeight = '';
        }
      });
    }

    function initAll() {
      document.querySelectorAll('[data-product-description-expandable]').forEach(initExpandableDescription);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
